// libs
import React from 'react';

// components
import SizeGuideBottomSheetDesktop from './Desktop';
import SizeGuideBottomSheetMobile from './Mobile';

function SizeGuideBottomSheet({
  isMobile,
  onClose,
  showSizeChart,
}: {
  isMobile: boolean;
  onClose: () => void;
  showSizeChart: boolean;
}) {
  if (showSizeChart === false) {
    return null;
  }

  if (isMobile) {
    return <SizeGuideBottomSheetMobile onClose={onClose} />;
  }

  return <SizeGuideBottomSheetDesktop onClose={onClose} />;
}

export default SizeGuideBottomSheet;
